import { h } from 'preact'
import { Text } from 'preact-i18n'
import { noop } from '../utils'
import ColorDot from './ColorDot'

export default ({options = [], title, selected, onChange = noop, textDomain}) =>
    <div class="limba__panel-attr">
        <h2><Text id={title} /></h2>
        {options.map(option => 
            <ColorDot 
                color    = {"#" + option.hexcolor}
                label    = {textDomain + '.' + option.color}
                classes  = ""
                material = {option.material}
                pattern  = {option.pattern}
                onClick  = {() => onChange(option)}
                selected = {option.color == selected.color}
            /> 
        )}
    </div>


// WEBPACK FOOTER //
// ./js/components/ColorPicker.js